<div class="qr-scanner-screen">
	<!-- HEADER -->
	<div class="qs-header">
		<div class="qs-header-left">
			<button type="button" class="qs-back-btn" (click)="goBack()">
				<i class="fas fa-arrow-left"></i>
			</button>

			<div class="qs-header-title-wrapper">
				<div class="qs-logo">
					<i class="fas fa-qrcode"></i>
				</div>
				<h1 class="qs-title">
					STOCK CONTROL - {{this.modeText.toUpperCase()}}
				</h1>
			</div>
		</div>

		<div class="qs-clock">
			<span> {{ dateTime | date: 'EEE d MMM HH:mm' }} </span>
		</div>
	</div>

	<!-- MAIN -->
	<div class="qs-main">
		<div class="qs-main-inner">
			<!-- OPERATION SELECTOR -->
			<!-- <div class="qs-operation-selector">
        <button
          type="button"
          class="qs-mode-btn"
          [ngClass]="{
            'qs-mode-btn-active': mode === 'in',
            'qs-mode-btn-inactive': mode === 'out'
          }"
          (click)="switchMode('in')"
        >
          <span>Check In</span>
        </button>

        <button
          type="button"
          class="qs-mode-btn"
          [ngClass]="{
            'qs-mode-btn-active': mode === 'out',
            'qs-mode-btn-inactive': mode === 'in'
          }"
          (click)="switchMode('out')"
        >
          <span>Check Out</span>
        </button>
      </div> -->

			<!-- SCANNER CONTAINER -->
			<div class="qs-scanner-container">
				<div class="qs-scanner-content">
					<div class="qs-camera-view">
						<div class="qs-camera-frame">
							<zxing-scanner
								#scanner
								[formats]="[allowedFormats]"
								[device]="selectedDevice"
								(camerasFound)="cameraFound($event)"
								(camerasNotFound)="camerasNotFound()"
								(scanSuccess)="onScanSuccess($event)"
								style="
									width: 100% !important;
									height: 100% !important;
								"
							>
							</zxing-scanner>
						</div>

						<div class="qs-camera-overlay-center">
							<i class="fas fa-camera qs-camera-icon"></i>
							<p class="qs-camera-text">
								Position QR code within the frame
							</p>
						</div>

						<div
							class="qs-scanning-line"
							[ngStyle]="{ top: scanningLineTop + 'px' }"
						></div>
					</div>

					<!-- <div class="qs-controls-row">
						<button
							type="button"
							class="qs-round-btn"
							(click)="onToggleFlash()"
						>
							<i class="fas fa-bolt"></i>
						</button>

						<button
							type="button"
							class="qs-round-btn"
							(click)="onSwitchCamera()"
						>
							<i class="fas fa-sync"></i>
						</button>
					</div> -->

					<div class="qs-scan-status">
						<div class="qs-scan-status-main">
							<i class="fas fa-circle qs-status-dot"></i>
							<span class="qs-status-label">Ready to scan</span>
						</div>
						<p class="qs-status-helper">
							Align QR code within the frame to scan
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- PIN MODAL -->
	<!-- PIN ACCESS MODAL -->
	<div class="qs-modal-backdrop" *ngIf="showPinModal">
		<div class="qs-modal">
			<div class="qs-modal-body">
				<h3 class="qs-result-title">Enter PIN (4–8 digits)</h3>

				<!-- PIN DOTS -->
				<div class="qs-pin-dots">
					<div
						class="qs-pin-dot"
						*ngFor="let _ of pinSlots; let i = index"
						[ngClass]="{ 'qs-pin-dot-filled': i < pinInput.length }"
					></div>
				</div>

				<div class="qs-pin-error" *ngIf="pinError">{{ pinError }}</div>

				<!-- KEYPAD -->
				<div class="qs-pin-keypad">
					<div class="qs-pin-row">
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('1')"
						>
							1
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('2')"
						>
							2
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('3')"
						>
							3
						</button>
					</div>
					<div class="qs-pin-row">
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('4')"
						>
							4
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('5')"
						>
							5
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('6')"
						>
							6
						</button>
					</div>
					<div class="qs-pin-row">
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('7')"
						>
							7
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('8')"
						>
							8
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('9')"
						>
							9
						</button>
					</div>
					<div class="qs-pin-row">
						<button
							type="button"
							class="qs-key-btn qs-key-btn-back"
							(click)="onBackspace()"
							[disabled]="pinInput.length === 0"
						>
							<i class="fas fa-backspace"></i>
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-number"
							(click)="onDigitPress('0')"
						>
							0
						</button>
						<button
							type="button"
							class="qs-key-btn qs-key-btn-ok"
							(click)="onOkPress()"
							[disabled]="!canSubmit()"
						>
							<i class="fas fa-check"></i>
						</button>
					</div>
				</div>

				<!-- ACTION BUTTONS -->
				<div class="qs-modal-actions-bottom">
					<button
						type="button"
						class="qs-secondary-btn-wide"
						(click)="goBack()"
					>
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- SCAN RESULT MODAL -->
	<!-- <div
    class="qs-modal-backdrop"
    *ngIf="false"
  >
    <div class="qs-modal">
      <div class="qs-modal-body">
        <div
          class="qs-result-icon-wrapper"
          [ngClass]="{
            'qs-result-icon-success': resultType === 'success',
            'qs-result-icon-error': resultType === 'error'
          }"
        >
          <i
            class="fa-solid"
            [ngClass]="{
              'fa-check': resultType === 'success',
              'fa-xmark': resultType === 'error'
            }"
          ></i>
        </div>

        <h3 class="qs-result-title">
          {{ resultTitle }}
        </h3>

        <p class="qs-result-message">
          {{ resultMessage }}
        </p>

        <div class="qs-modal-actions">
          <button
            type="button"
            class="qs-primary-btn"
            (click)="onScanAnother()"
          >
            Scan Another
          </button>

          <button
            type="button"
            class="qs-secondary-btn"
            (click)="onViewDetails()"
          >
            View Details
          </button>
        </div>
      </div>
    </div> 
  </div> -->
</div>

<!-- <div class="operator-bg" style="width:100vw; height:100vh;">
	<div class="row" style="width:50vw; margin-left:0.5vw">
		<h2 style="color:white; margin-top: 15px; margin-left:15px;">STOCK CONTROL INTERFACE</h2>
		<h3 style="color:#77787E; margin-left:15px; margin-bottom: 15px;">{{modeText.toUpperCase()}}</h3>
	</div>
	<div class="row" style="margin-left:0.5vw">
		<select id="deviceId" #Id="ngModel" class="hideLabel form-control" [(ngModel)]="selectedDevice" name="label" aria-placeholder="Select Camera" style="width:50vw;border-radius:0px; height:100px; font-size: 40px;" (change)="onDeviceSelectChange();">	 
		 <option [ngValue]="k.deviceId" *ngFor="let k of availableDevices">  
			 {{k.label}}  
	  </option>  
	</select>  
	</div>
<zxing-scanner
  #scanner
  [formats]="[allowedFormats]"
  [device]="selectedDevice"
  (camerasFound)="cameraFound($event)"
  (camerasNotFound)="camerasNotFound()"
  (scanSuccess)="onScanSuccess($event)"
  style="width:50vw !important; margin-left:0.5vw; margin-top:-100px"
>
</zxing-scanner> -->
<!-- <div *ngIf="availableDevices">
    <select (change)="onDeviceSelectChange(event.target.value)">
        <option value="" [selected]="!selectedDevice">No Device</option>
        <option *ngFor="let device of availableDevices" [value]="device.deviceId" [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}</option>
    </select>
</div> -->
